"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountOrEnterpriseUid = exports.AccountUid = exports.UserUid = exports.optionalOrganizationUid = exports.OrganizationUid = exports.ReviewColumnUid = exports.ReviewCheckUid = exports.ReviewUid = exports.EnterpriseUid = exports.DocumentUid = void 0;
exports.createNewEnterpriseUid = createNewEnterpriseUid;
exports.isEnterpriseUid = isEnterpriseUid;
exports.createNewReviewUid = createNewReviewUid;
exports.isReviewUid = isReviewUid;
exports.createNewReviewCheckUid = createNewReviewCheckUid;
exports.isReviewCheckUid = isReviewCheckUid;
exports.createNewReviewColumnUid = createNewReviewColumnUid;
exports.isReviewColumnUid = isReviewColumnUid;
exports.createNewOrganizationUid = createNewOrganizationUid;
exports.isOrganizationUid = isOrganizationUid;
exports.brandVertexUid = brandVertexUid;
const tslib_1 = require("tslib");
const shared_1 = require("@buildwithflux/shared");
const zod_1 = tslib_1.__importDefault(require("zod"));
/**
 * A document UID is a UUID string
 *
 * @todo Use a branded string
 */
exports.DocumentUid = zod_1.default.string().length(36);
exports.EnterpriseUid = zod_1.default
    .string()
    .startsWith("ent_")
    .refine((val) => !!val);
function createNewEnterpriseUid() {
    return exports.EnterpriseUid.parse(`ent_${(0, shared_1.guid)()}`);
}
function isEnterpriseUid(identifier) {
    return exports.EnterpriseUid.safeParse(identifier).success;
}
exports.ReviewUid = zod_1.default
    .string()
    .startsWith("rev_")
    .refine((val) => !!val);
function createNewReviewUid(type) {
    return exports.ReviewUid.parse(`rev_${type}`);
}
function isReviewUid(identifier) {
    return exports.ReviewUid.safeParse(identifier).success;
}
exports.ReviewCheckUid = zod_1.default
    .string()
    .startsWith("rch_")
    .refine((val) => !!val);
function createNewReviewCheckUid(name) {
    return exports.ReviewCheckUid.parse(`rch_${name.replace(/\s+/g, "_").toLowerCase()}`);
}
function isReviewCheckUid(identifier) {
    return exports.ReviewCheckUid.safeParse(identifier).success;
}
exports.ReviewColumnUid = zod_1.default
    .string()
    .startsWith("rcl_")
    .refine((val) => !!val);
function createNewReviewColumnUid(name) {
    return exports.ReviewColumnUid.parse(`rcl_${name.replace(/\s+/g, "_").toLowerCase()}`);
}
function isReviewColumnUid(identifier) {
    return exports.ReviewColumnUid.safeParse(identifier).success;
}
exports.OrganizationUid = zod_1.default
    .string()
    .startsWith("org_")
    .refine((val) => !!val);
exports.optionalOrganizationUid = zod_1.default.preprocess((v) => v ?? undefined, exports.OrganizationUid.optional());
function createNewOrganizationUid() {
    return `org_${(0, shared_1.guid)()}`;
}
function isOrganizationUid(identifier) {
    return exports.OrganizationUid.safeParse(identifier).success;
}
/**
 * A user UID is an alphanumeric string generated by Firebase auth
 *
 * This appears as a foreign key property on the main user interface IUserData, and is used to link the user to both:
 *  - The FirestoreAuth user, and
 *  - The user's private metadata bundle of properties (currently used for subscription information, private project counts, etc.)
 */
exports.UserUid = zod_1.default.string().min(2);
exports.AccountUid = zod_1.default.string().min(2);
exports.AccountOrEnterpriseUid = zod_1.default.string().min(2);
function brandVertexUid(uid) {
    // No checking here. This is simply to help us avoid mixing uid types by opting into the
    // branded type as early as possible.
    return uid;
}
//# sourceMappingURL=identifier.js.map